import AbstractModel, { Model, DateType } from './abstract-model';
import CavCusActionAdministrative from './cav-cus-action-administrative';
import { LexCusEtatGeneral, LexCusPositionnement, LexCusTypeOuvrage } from './gen-lexs';
import CavCusActionEntreprise from './cav-cus-action-entreprise';
import CavCusActionJuridique from './cav-cus-action-juridique';
import CavCusActionReglementaire from './cav-cus-action-reglementaire';
import CavCusProprietaire from './cav-cus-proprietaire';
import CavCusResteAFaire from './cav-cus-reste-a-faire';
import CavCusTravaux from './cav-cus-travaux';
import CavCusPlan from './cav-cus-plan';
import CavCusAccesContactAdresse from './cav-cus-acces-contact-adresse';
import CavCusAlea from './cav-cus-Alea';
import CavCusDesordre from './cav-cus-desordre';
import CavCusMiseSecurite from './cav-cus-mise-securite';
import CavitesEtiquette from './cavites-etiquette';
import CavitesIndice from './cavites-indice';
import CavitesLine from './cavites-line';
import CavitesPoints from './cavites-points';
import CavitesPolygon from './cavites-polygon';

@Model('CavCus')
export default class CavCus extends AbstractModel {
  public  idCavite: string = null;
  public  identifiant: string = null;
  public  typeSiteCommentaire: string = null;
  public  adresseSite: string = null;
  public  telSite: string = null;
  public  cSection: string = null;
  public  noParcelle: string = null;
  public  positionnement: LexCusPositionnement = null;
  public  typeOuvrage: LexCusTypeOuvrage = null;
  public  typeOuvrageCommentaire: string = null;
  public  precisionLeve: string = null;
  public  observationConnaissance: string = null;
  public  largeurEnveloppe: number = null;
  public  longueurEnveloppe: number = null;
  public  hauteurMaxCavite: number = null;
  public  largeurMaxCavite: number = null;
  public  longueurMaxCavite: number = null;
  public  surfaceMaxCavite: number = null;
  public  volumeTotal: number = null;
  public  nbNiveau: number = null;
  public  profMinToit: number = null;
  public  profRadier: number = null;
  public  surfaceEmprise: number = null;
  public  epaisseurSoutenement: string = null;
  public  existenceReseau: string = null;
  public  existenceDigit: string = null;
  public  etatGeneral: LexCusEtatGeneral = null;
  public  existenceActions: string = null;
  public  actionsRéglementaires: string = null;
  public  actionAdministratives: CavCusActionAdministrative[] = [];
  public  actionEntreprises: CavCusActionEntreprise[] = [];
  public  actionJuridiques: CavCusActionJuridique[] = [];
  public  actionReglementaires: CavCusActionReglementaire[] = [];
  public  proprietaires: CavCusProprietaire[] = [];
  public  resteAFaires: CavCusResteAFaire[] = [];
  public  travaux: CavCusTravaux[] = [];
  public  plans: CavCusPlan[] = [];
  public  accesContactAdresses: CavCusAccesContactAdresse[] = [];
  public  aleas: CavCusAlea[] = [];
  public  desordres: CavCusDesordre[] = [];
  public  miseSecurites: CavCusMiseSecurite[] = [];
  public  cavitesEtiquettes: CavitesEtiquette[] = [];
  public  cavitesIndices: CavitesIndice[] = [];
  public  cavitesLines: CavitesLine[] = [];
  public  cavitesPointss: CavitesPoints[] = [];
  public  cavitesPolygons: CavitesPolygon[] = [];
  public  memoActions: string = null;
  @DateType() public  cDateModif: Date = null;
  public  cUserModif: string = null;
  public  shpTempDir: string = null;
}

